import styles from "./purchaseHistory.module.css";

const workInProgressStyle = {
    outerContainer: `flex flex-col gap-4 w-full container pb-4`,
    header: `flex gap-2 justify-between items-center`,
    heading: `text-[20px] sm:text-[22px] font-[400]`,
    historyTabs: `w-full flex justify-between items-end ${styles.historyTabs}`,
    tabContainer: `flex w-full p-[10px] pt-0 pb-0 overflow-auto relative`,
    tab: `cursor-pointer text-center w-[160px] p-[10px] ${styles.tab}`,
    tabName: `p-2 whitespace-nowrap text-[14px] sm:text-[16px]`,
    activeButton: `${styles.activeButton}`,
    // activeTab: `w-full h-[2px] rounded-t-[4px] bg-primaryHeading mt-[5px]`,
    noPurchaseHistory: `flex flex-col pt-[15px] md:pt-[30px] items-center justify-center md:gap-2`,
    noPurchaseImg: `w-full h-auto max-w-[200px]`,
    filtersOnSmallScreen: `flex gap-2 
                           md:hidden                        
    `,
    spinnerContainer: `flex justify-center items-center py-[20px]`,
    filtersForLargeScreens: `hidden 
                             md:block
    `,
    filters: `block
              md:hidden            
    `,
    divider: `w-full h-[1px] bg-white`,
    searchContainer: `flex gap-2`


}

const PurchasedTokensStyle = {
    container: `flex flex-col  bg-liveGameBackground rounded-[10px] px-[15px] py-[10px] mb-2
                md:px-[20px] md:py-[15px] ${styles.container1}
    `,
    spinnerContainer: `flex justify-center items-center w-full`,
    headerContainer: `flex gap-3 items-center ${styles.headerContainer}`,
    heading: ` text-[15px] sm:text-[18px] font-[500] flex items-center gap-2 min-w-[150px] ${styles.heading} `,
    orderCode: `text-[14px] md:text-[16px] break-all sm:max-w-full`,
    header: `flex flex-row justify-between gap-2 ${styles.header}`,
    payment_text: `payment_text`,
    totalText: `text-[14px] sm:text-[17px] font-[500]`,
    paymentMethod: `text-[14px] md:text-[16px] capitalize ${styles.paymentMethod}`,
    orderId: `flex flex-col orderId`,
    date: `text-[14px] ${styles.date}`,
    orderDate: `flex flex-row gap-[10px] text-[14px]
                md:flex-col md:gap-0
    `,
    orderDetails: `flex flex-col gap-2
                   md:flex-row md:gap-[30px]
    `,
    total_status: `flex flex-row gap-[20px] ${styles.total_status}`,
    totalContainer: `flex flex-col gap-[5px] ${styles.totalContainer}`,
    total: `flex flex-row gap-[10px]
            md:flex-col md:gap-0 
    `,
    detailsSection: `flex gap-[30px] flex-col mt-4 ${styles.detailsSection}  `,
    tokenDetails: `flex flex-col w-full overflow-x-auto rounded-[10px] bg-themeColor`,
    subDetails: `flex w-full justify-between flex-col cursor-pointer
                md:flex-row
    `,
    headers: `font-[400] text-[16px] bg-gradient-to-b from-[#e2e8ff00] to-[#e2e8ff1f] text-white px-[14px] py-[7px] rounded-[8px] z-10 w-full text-center ${styles.headers}`,
    subtotal: `flex flex-row gap-2 items-baseline`,
    details: `flex gap-[10px] 
                md:flex-col
    `,
    orderDetailsContainer: `flex-flex-col gap-2`,
    detailsInnerContainer: `flex flex-row items-start gap-[20px] ${styles.detailsInnerContainer} `,
    tokenImageContainer: `flex flex-col rounded-[10px] gap-0 sm:items-center ${styles.tokenImageContainer}`,
    imageContainer: `px-[28px] pt-[12px] pb-[0px] bg-themeColor rounded-[8px] flex items-center justify-center ${styles.imageContainer}`,
    tokenImage: `w-full max-w-[53px] ${styles.tokenImage}`,
}

const orderDetailsTableStyle = {
    container: `px-[14px] py-[10px] ${styles.container}`,
    table: `w-full table-auto ${styles.table}`,
    innerTableHead: `font-[500] col-span-1 px-4 py-2 text-left ${styles.innerTableHead}`,
    innerTableBody: `font-[300] col-span-1 px-4 py-2 ${styles.innerTableBody}`,
    innermainTableBody: `grid grid-cols-3 !p-0`,
    tableHead: `px-4 py-2 text-left`,
    tableBody: `px-4 py-2`,
    lastItemBorder: `b-bottom`,
    hoverImage: `cursor-pointer max-w-[20px] min-w-[20px] w-full h-auto`,
    hoveredContainer: `py-1 w-max rounded-[6px] z-10`,
    hoverList: `flex justify-between items-center gap-2`,
    button: `w-full flex items-center justify-center`,
    border: `border-b border-gray-200 border-opacity-20`,
    deleteIcon: `max-w-[20px] w-full`,
}

const buyedPointsStyle = {
    spinnerContainer: `flex justify-center items-center w-full`,
    outerContainer: `flex flex-col gap-[20px] md:gap-[50px]`,
    innerContainer: `flex flex-col gap-4 justify-center`,
    heading: `text-[22px] font-Suisse uppercase
              md:text-[28px]
              lg:text-[32px]
    `,
    purchaseHistoryContainer: `flex flex-col gap-4`,
    purchaseItem: `flex gap-4 bg-themeOverlay rounded-[10px] px-[15px] py-[10px]
                    md:px-[20px] md:py-[15px] mb-1
    `,
    purchaseDetailsContainer: `flex gap-3 w-full flex-row items-center ${styles.purchaseDetailsContainer}`,
    point_chipContainer: `${styles.point_chipContainer}`,
    pointImage: `max-w-[70px] rounded-[10px] bg-themeColor`,
    point_chip: `mb-auto mt-[7px] !hidden ${styles.point_chip}`,
    point_chip_lg: `mb-auto ${styles.point_chip_lg}`,
    purchaseDetails: `flex flex-1 w-full flex-row items-baseline justify-between ${styles.purchaseDetails} `,
    pointsPurchased: `flex flex-col gap-[5px] w-[140px] ${styles.pointsPurchased}`,
    purchaseDetailsHeadings: `font-[500] text-[18px] min-w-[155px] max-w-[155px] ${styles.purchaseDetailsHeadings} `,
    pointDetailsHeadings: `font-[500] text-[18px] min-w-[60px] max-w-[60px] ${styles.purchaseDetailsHeadings}
    `,
    point_data: `text-[16px] ${styles.point_data}`,
    amount_data: `text-[13px] sm:text-[17px] font-[400]`,
    point_transactionId: `break-all text-[14px] md:text-[16px] ${styles.point_transactionId}`,
    purchaseDate: `flex flex-col text-[14px]`,
    transactionContainer: `flex items-baseline`,
    // purchasePoint: `flex flex-row md:flex-col`,
    purchasePoints: `flex flex-row text-[14px] items-baseline`,
    paymentMethod: `flex gap-2 items-center ${styles.paymentMethod}`,
    detail_text: `text-[14px] md:text-[16px] capitalize ${styles.paymentMethod}`,
    purchaseAmount: `flex flex-row gap-[0px] items-baseline`,
    // label: `font`,
    buttonContainer: `flex gap-4 mt-4`,
    button: `bg-primaryButtonColor text-white rounded-[4px] px-[12px] py-[6px] cursor-pointer hover:bg-primaryButtonHoverColor`,
};

const dateFilterStyle = {
    filter_section: `flex flex-col w-full justify-end items-start gap-2 rounded-[10px] mb-2 ${styles.filter_section} 
                     md:ml-auto md:items-center md:flex-row md:px-3 md:py-1
  `,
    date_filters: `flex flex-col gap-2 w-full items-center
                   sm:flex-row
    `,
    input_container: `flex items-baseline w-full relative gap-[10px]`,
    label: `block text-[13px] ${styles.label}`,
    apply_button: `bg-primaryHeading text-white rounded-[15px] px-3 py-1 focus:outline-none text-[14px] w-full ${styles.apply_button}
        md:max-w-[unset] gap-2`,
    date_input: `px-1 bg-transparent text-white uppercase block w-full rounded-md focus:border-none focus:ring-none text-[13px] outline-none ${styles.date_input} 
      sm:text-[12px]`,
    buttonsContainer: `flex gap-2 w-full`,
    clear_button: `bg-primaryHeading text-white rounded-[15px] px-3 py-1 focus:outline-none text-[12px] max-w-[60px]`,
    textBetween: `text-[14px] font-300 hidden
                  md:block
    `,
}

export { workInProgressStyle, PurchasedTokensStyle, orderDetailsTableStyle, buyedPointsStyle, dateFilterStyle };